import compuedFun from '../../../computed/'
const { showName } = compuedFun()

export const rules = {
  line_id: [ { required: true, message: '请选择上级分类', trigger: 'change' } ],
  type_name: [ { required: true, message: '请输入分类名称', trigger: 'change' } ]
}

export const form = {
  line_id: [],
  type_name: '',
  name: '',
  title: '',
  keywords: '',
  description: '',
  is_show: 1,
  sort: '',
}

export const columns = [
  {
    title: '分类名称',
    dataIndex: 'type_name',
    width: 300,
    align: 'left'
  },
  {
    title: 'ID',
    dataIndex: 'id',
    width: 100,
    align: 'left'
  },
  {
    title: '分类简写',
    dataIndex: 'name',
    width: 170,
    align: 'left'
  },
  {
    title: '分类标题',
    dataIndex: 'title',
    width: 170,
    align: 'left'
  },
  {
    title: '描述',
    width: 300,
    dataIndex: 'description',
    align: 'left'
  },
  {
    title: '关键字',
    width: 100,
    dataIndex: 'keywords',
    align: 'left'
  },
  {
    title: '是否显示',
    dataIndex: 'is_show',
    align: 'left',
    customRender(text) {
      return showName('ARTICLE_TYPE_IS_SHOW', text)
    }
  },
  {
    title: '排序',
    dataIndex: 'sort',
    align: 'left'
  },
  {
    title: '操作',
    align: 'center',
    width: 240,
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' }
  }
]
